import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Box from 'components/Box';
import Icon from 'components/Icon';
import TextLink from 'components/TextLink';
import useBackLink from 'hooks/useBackLink';
function PageBackLink(_ref) {
  var children = _ref.children,
    to = _ref.to,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? '/' : _ref$fallback,
    basePath = _ref.basePath,
    shouldSkipLocation = _ref.shouldSkipLocation,
    _ref$mb = _ref.mb,
    mb = _ref$mb === void 0 ? 'm' : _ref$mb;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var backLink = useBackLink({
    shouldSkipLocation: shouldSkipLocation,
    basePath: basePath,
    fallback: fallback
  });
  return /*#__PURE__*/React.createElement(Box, {
    mb: mb
  }, /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    as: Link,
    to: to || backLink
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrow",
    vAlign: true,
    mr: "xxs"
  }), children || t('actions_back')));
}
export default PageBackLink;